module.exports = __webpack_public_path__ + "media/soundtrack.fccf53fc.mp3";